import React, { useEffect, useState } from "react";
import ForUs from "../DarazMall/ForUs";
import "./productinfo.css";
import { datazproducts } from "../DarazMall/datazproducts";
import Offer from "./Offer";
// importing icons
import ShareIcon from "@mui/icons-material/Share";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import axios from "axios";

function ProductInfo() {
  const [count, setCount] = useState(1);
  const mall = true;
  const [product, setProduct] = useState([]);

  useEffect(() => {
    axios
      .get(`../Products/flashproductdata.js`)
      .then((data) => setProduct(data));
  }, []);

  console.log(product);

  return (
    <div className="containers">
      <div className="productinfo-containers">
        <div className="productinfo-details">
          <div className="product-image">
            {/* image */}
            <img
              src="https://static-01.daraz.com.np/p/09a5818a51c5050e40fb2642dab447b0.jpg_200x200q90-product.jpg_.webp"
              alt=""
            />
            {/* small image */}
          </div>

          <div className="product-information">
            {/* title */}
            <div className="prodcuinfo-title">
              {mall ? (
                <div className="darazinfo-mall">
                  <p>mall</p>
                </div>
              ) : (
                <div></div>
              )}
              <h3>Dash 02 Goldstar Black Shoes for Men</h3>
            </div>

            <div className="productinfo-rating">
              {/* rating */}
              <div className="product-stars">
                {Array(5)
                  .fill(0, 0, 5)
                  .map((i) => (
                    <p className="star-image">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Star_icon_stylized.svg/1077px-Star_icon_stylized.svg.png"
                        alt=""
                      />
                    </p>
                  ))}
                {/* icons */}
                <h3> 1 Ratings</h3>
              </div>
              <div className="icons-share">
                <p>
                  <ShareIcon />
                </p>
                <p>
                  <FavoriteBorderIcon />
                </p>
              </div>
            </div>
            <div className="pricing">
              <p className="active"> Rs. 853 </p>
              <p className="discount">
                <s>Rs.1065</s>-20%
              </p>

              {/*Offer */}
              <div className="promotion">
                <p>Promotions</p>
                <Offer />
              </div>
            </div>

            <div className="sizes">
              <p>Size</p>
              <div className="size-country">
                <p>UK</p>
                <div>
                  <p>10</p>
                  <p>9</p>
                  <p>8</p>
                  <p>7</p>
                  <p>6</p>
                </div>
              </div>
            </div>
            <div className="quantity">
              <h3>Quantity</h3>
              <button onClick={() => setCount((count) => count - 1)}>
                {" "}
                -{" "}
              </button>
              <p>{count}</p>
              <button onClick={() => setCount((count) => count + 1)}>+</button>
            </div>

            <div className="buttons">
              <button className="buynow">Buy Now</button>
              <button className="addtocart">Add to Cart</button>
            </div>
          </div>
        </div>

        <div>
          <ForUs darazproduct={datazproducts} />
        </div>
      </div>
    </div>
  );
}

export default ProductInfo;
